import { useEffect } from 'react';
import CyanEllips from '../../assets/images/utils/cyan-ellips.png';
import Drawer from '../../Components/Drawer';
import ChestHeading from '../../pages/Chest/components/ChestHeading';
import { useAppDispatch } from '../../store';
import { openChest } from '../../store/reducers/chests/asyncActions';
import {
  TChestHistoryResponse,
  TChestRewardHistory,
} from '../../types';
import ChestSpinner from '../ChestSpinner';
import { useSpinAnimation } from '../ChestSpinner/hooks/useSpineAnimation';

type TChestSpinnerModalProps = {
    open: boolean;
    chestHistory?: TChestHistoryResponse
    onFinish?: (reward: TChestRewardHistory) => (Promise<void> | void)
}

function ChestSpinnerModal({
  open, chestHistory, onFinish,
}: TChestSpinnerModalProps) {
  const dispatch = useAppDispatch();

  const {
    scope, x, spinLine, spin,
  } = useSpinAnimation({ rewards: chestHistory?.chest.chest_rewards ?? [] }, {
    onFinish,
  });

  useEffect(() => {
    if (!!chestHistory && chestHistory.status === 'owned' && open) {
      const handler = async () => {
        const result = await dispatch(openChest({ id: chestHistory.id }));

        if (result.error) {
          return;
        }

        setTimeout(() => {
          spin(result.payload);
        }, 1_000);
      };

      handler();
    }
  }, [chestHistory, open]);

  return (
    <Drawer
      open={open && !!chestHistory}
      side="bottom"
      wrapperClassName="flex flex-col shadow-xl rounded-t-[20px] z-[1800] relative bg-chestSpinnerModalBg overflow-hidden pb-[80px]"
      hideClose
    >
      {open && chestHistory && (
        <>
          <div className="relative mt-[100px]">
            <ChestHeading chest={chestHistory.chest} rewardToCollect={undefined} />
            <img src={CyanEllips} alt="cyan-ellips" className="absolute top-0 left-[50%] transform translate-y-[-50%] translate-x-[-50%] z-[-1]" />
          </div>
          <span className="font-Barlow text-sm text-center text-[#9C9DA9]">{chestHistory.chest.description}</span>
          <div className="mt-6">
            <ChestSpinner
              chest={chestHistory.chest}
              scope={scope}
              spinLine={spinLine}
              x={x}
              multiplier={chestHistory.multiplier}
            />
          </div>
        </>
      )}
    </Drawer>
  );
}

export default ChestSpinnerModal;
